//====================================================
//  Function: Slider
//====================================================
function fn_components_slider(){
	fn_detail_slider();
}


function fn_detail_slider(){
	if ($('.js-slider-main-product').length) {
		$('.js-slider-main-product').slick({
			infinite: true,
			dots: false,
			slidesToShow:1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			autoplaySpeed: 2000,
			cssEase: 'linear',
			speed: 500,
			fade: true,
			// nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			// prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			variableWidth: false,
			mobileFirst: true,
			asNavFor: '.js-slider-thumbnail-product'
		});
	}

	$('.js-slider-thumbnail-product').on('init', function(event, slick, direction){
		$('.js-slider-thumbnail-product').resize();
	});

	if ($('.js-slider-thumbnail-product').length) {
		$('.js-slider-thumbnail-product').slick({
			infinite: true,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			// centerMode: true,
			autoplaySpeed: 2000,
			cssEase: 'linear',
			speed: 500,
			asNavFor: '.js-slider-main-product',
			focusOnSelect: true,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-down"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-up"></i></span>',
			vertical: true,
			verticalSwiping: true,
			responsive: [
                  {
                    breakpoint: 1220,
                    settings: {
						vertical: true,
						verticalSwiping: true,
						nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-down"></i></span>',
						prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-up"></i></span>',
                      	slidesToShow: 4
                    }
                  },
                  {
                    breakpoint: 990,
                    settings: {
                    	vertical: true,
						verticalSwiping: true,
						nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-down"></i></span>',
						prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-up"></i></span>',
                      	slidesToShow:4
                    }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                    	vertical: false,
						verticalSwiping: false,
						nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
						prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
                      	slidesToShow:3
                    }
                  },
                  {
                    breakpoint: 550,
                    settings: {
                    	vertical: false,
						verticalSwiping: false,
						nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
						prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
                      	slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 250,
                    settings: {
                    	vertical: false,
						verticalSwiping: false,
						nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
						prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
                      	slidesToShow:2
                    }
                  }
              ]
		});
	}
}


